import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_CAROUSEL_MEMBERSHIP_CONFIGURATION = defineFcm('carousel_membership_configuration')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				amount_base_units: {
					type: 'number',
				},
				contribute_url: {
					type: 'string',
					optional: true,
				},
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'TBD',
		scope: 'corgi-front-end',
		context: 'Petition discover page (carousel)',
		description: `Defines whether there should be a membership interstitial card and its configuration.

		If "contribute_url" is set, it will override a default url targeting the default membership page (useful for 3rd-party pages).`,
		template: {
			amount_base_units: 300,
			contribute_url: undefined,
		},
	});
